import { useTranslation } from 'react-i18next';
import { useBreakdownsFilterContext } from '../BreakdownsFilterContext';
import { DoubleRangeSlider } from '../../../../SourcesPage/Filter/DoubleRangeSlider/DoubleRangeSlider';
import { ContentContainer } from '../../../../../components/Filters/components/ContentContainer';
import { ControlsPanel } from '../../../../../components/Filters/components/ControlsPanel';

const AUDIENCE_MIN = 0;
const AUDIENCE_MAX = 1000000000;

export const AudienceChooser = () => {
  const { t } = useTranslation();
  const { state, updateDraftFilters } = useBreakdownsFilterContext();

  const audienceFilter = state.draftFilters.audience;
  const audienceRange = audienceFilter.value;
  const isActive = audienceRange[0] > AUDIENCE_MIN || audienceRange[1] < AUDIENCE_MAX;

  const handleClearAll = () => {
    updateDraftFilters({ audience: { value: [AUDIENCE_MIN, AUDIENCE_MAX], exclude: false } });
  };

  return (
    <ContentContainer
      actionsComponent={
        <ControlsPanel
          id="breakdown-audience-filter"
          count={isActive ? 1 : 0}
          isExclude={audienceFilter.exclude}
          showExcludeSwitch={true}
          showSelectAll={false}
          onClearAll={handleClearAll}
          onExcludeClick={() => {
            updateDraftFilters({
              audience: {
                value: audienceRange,
                exclude: !audienceFilter.exclude,
              },
            });
          }}
        />
      }
    >
      <DoubleRangeSlider
        min={AUDIENCE_MIN}
        max={AUDIENCE_MAX}
        step={1}
        audienceRange={audienceRange}
        onChange={(range) => {
          updateDraftFilters({
            audience: {
              value: [Number(range[0]), Number(range[1])],
              exclude: audienceFilter.exclude,
            },
          });
        }}
      />
    </ContentContainer>
  );
};
